/**
 * stripe_pe.js — Stripe Payment Element (multi-metodo).
 * Attivato da ENV.USE_STRIPE_PAYMENT_ELEMENT = true.
 * Supporta: carte, Apple Pay, Google Pay, SEPA Direct Debit, Klarna, ecc.
 * L'interfaccia pubblica (init / createPaymentMethod) è identica a StripeController
 * così payment.js non cambia logica, solo quale controller usare.
 * Dipende da: env.js, state.js
 */
const StripePaymentElementController = {

    stripe:      null,
    elements:    null,
    initialized: false,

    // amountCents: importo in centesimi (es. 2550 = € 25,50)
    init(amountCents) {
        if (this.initialized) return;
        if (typeof Stripe === 'undefined') {
            console.warn('[Stripe PE] Stripe.js non ancora caricato');
            return;
        }
        const container = document.getElementById('stripe-payment-element');
        if (!container) return;

        this.stripe   = Stripe(ENV.stripeKey);
        this.elements = this.stripe.elements({
            mode:                  'payment',
            currency:              'eur',
            amount:                amountCents,
            paymentMethodCreation: 'manual',
            appearance: {
                theme: 'stripe',
                variables: {
                    colorPrimary:    '#0e1f3b',
                    colorBackground: '#f8f9fa',
                    fontFamily:      "'Inter', 'Source Sans 3', sans-serif",
                    borderRadius:    '8px',
                    spacingUnit:     '4px',
                },
                rules: {
                    '.Label':  { fontWeight: '500' },
                    '.Input':  { border: '1px solid #dee2e6', boxShadow: 'none' },
                },
            },
        });

        const paymentElement = this.elements.create('payment', {
            layout: { type: 'tabs', defaultCollapsed: false },
            // Ordine di visualizzazione dei metodi di pagamento.
            // Carte → flusso invoice (off-session). SEPA → invoice + mandate_data.
            // PayPal e metodi redirect → PaymentIntent con return_url (gestito dal backend).
            paymentMethodOrder: ['card', 'apple_pay', 'google_pay', 'sepa_debit', 'paypal'],
            defaultValues: {
                billingDetails: {
                    name:    `${BookingState.client.name || ''} ${BookingState.client.lastname || ''}`.trim(),
                    email:   BookingState.client.email  || '',
                    phone:   BookingState.client.phone  || '',
                    address: { country: 'IT' },
                },
            },
        });
        paymentElement.mount('#stripe-payment-element');

        this.initialized = true;
    },

    // Stessa firma di StripeController.createPaymentMethod() → restituisce PM ID
    async createPaymentMethod() {
        if (!this.stripe || !this.elements)
            throw new Error('Stripe non inizializzato. Ricarica la pagina e riprova.');

        // Valida il form interno del Payment Element prima di procedere
        const { error: submitError } = await this.elements.submit();
        if (submitError) throw new Error(submitError.message);

        const c = BookingState.client;
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
            elements: this.elements,
            params: {
                billing_details: {
                    name:    `${c.name} ${c.lastname}`.trim(),
                    email:   c.email,
                    phone:   c.phone,
                    address: { line1: c.address, country: 'IT' },
                },
            },
        });

        if (error) throw new Error(error.message);
        return { id: paymentMethod.id, type: paymentMethod.type };
    },
};

// Converte il totale (stringa o numero, es. "25.50" o 25) in centesimi interi
function totalToCents(total) {
    const n = parseFloat(String(total ?? '0').replace(',', '.'));
    return isNaN(n) || n <= 0 ? 100 : Math.round(n * 100);
}
